var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.143 16 19 21.192a26.55 26.55 0 0 1-13 0L7.857 16m9.286 0H7.857m9.286 0v-1.813c0-.683-.624-1.236-1.393-1.236-.77 0-1.393-.554-1.393-1.236v-.412h-.554M7.857 16v-1.813c0-.683.624-1.236 1.393-1.236.77 0 1.393-.554 1.393-1.236v-.412h.707m-2.1 7.829-.473 2.606m3.723-3.454v3.715m3.25-2.867.521 2.6m-2.468-10.43.054-8.124c0-1.57-2.452-1.57-2.452 0l-.055 8.125m2.453 0H11.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.06286ccab3476b88d5002663ed66c963.svg";
export { ForwardRef as ReactComponent };